import * as api from '../api/summary'

export const completeSessionFieldChanged = (field, subfield, value) => {
  return {
    type: 'COMPLETE_SESSION_FIELD_CHANGED',
    value: { field, subfield, value }
  }
}

export const closeSessionModal = () => ({ type: 'CLOSE_SESSION_MODAL' })

export const openSessionModal = () => ({ type: 'OPEN_SESSION_MODAL' })

export const clearCustomDeposit = () => ({ type: 'CLEAR_CUSTOM_DEPOSIT' })

export const sendEmail = () => {
  return (dispatch, getState) => {
    dispatch(sendSummaryRequested())
    api
      .sendSessionSummary(getState())
      .then(() => dispatch(sendSummarySuccess()))
      .catch(() => dispatch(sendSummaryFail()))
  }
}

const sendSummarySuccess = () => ({ type: 'SEND_SUMMARY_SUCCESS' })
const sendSummaryRequested = () => ({ type: 'SEND_SUMMARY_REQUESTED' })
const sendSummaryFail = () => ({ type: 'SEND_SUMMARY_FAIL' })



// WEBPACK FOOTER //
// ./src/actions/summary.js